<div class="w-full h-full flex flex-col">
  <div class="flex justify-between items-center mb-6">
    <h1 class="text-2xl font-semibold text-gray-900">Asistente</h1>
  </div>

  <div class="flex-1 bg-white rounded-lg shadow-sm border border-gray-200 flex flex-col overflow-hidden">
    <!-- Chat Messages Area -->
    <div #messagesContainer class="flex-1 overflow-y-auto p-6 space-y-4 bg-gray-50">
      @for (message of messages; track message.timestamp) {
        @if (message.isUser) {
          <!-- User Message -->
          <div class="flex justify-end">
            <div class="max-w-[70%] bg-blue-600 text-white rounded-lg px-4 py-3 shadow-sm">
              <p class="text-sm whitespace-pre-wrap break-words">{{ message.text }}</p>
              <span class="text-xs text-blue-100 mt-1 block">{{ message.timestamp | date:'HH:mm' }}</span>
            </div>
          </div>
        } @else {
          <!-- Bot Message -->
          <div class="flex justify-start">
            <div class="flex gap-3 max-w-[70%]">
              <div class="w-8 h-8 rounded-full bg-gray-300 flex items-center justify-center flex-shrink-0">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 text-gray-600">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M8.625 9.75a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 01.778-.332 48.294 48.294 0 005.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z" />
                </svg>
              </div>
              <div class="bg-white border border-gray-200 rounded-lg px-4 py-3 shadow-sm">
                <p class="text-sm text-gray-800 whitespace-pre-wrap break-words">{{ message.text }}</p>
                <span class="text-xs text-gray-400 mt-1 block">{{ message.timestamp | date:'HH:mm' }}</span>
              </div>
            </div>
          </div>
        }
      }

      @if (isTyping) {
        <!-- Typing Indicator -->
        <div class="flex justify-start">
          <div class="flex gap-3 max-w-[70%]">
            <div class="w-8 h-8 rounded-full bg-gray-300 flex items-center justify-center flex-shrink-0">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 text-gray-600">
                <path stroke-linecap="round" stroke-linejoin="round" d="M8.625 9.75a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 01.778-.332 48.294 48.294 0 005.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z" />
              </svg>
            </div>
            <div class="bg-white border border-gray-200 rounded-lg px-4 py-3 shadow-sm">
              <div class="flex gap-1">
                <span class="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style="animation-delay: 0ms;"></span>
                <span class="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style="animation-delay: 150ms;"></span>
                <span class="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style="animation-delay: 300ms;"></span>
              </div>
            </div>
          </div>
        </div>
      }
    </div>

    <!-- Input Area -->
    <div class="border-t border-gray-200 bg-white p-4">
      <div class="flex gap-3 items-end">
        <textarea
          [(ngModel)]="userInput"
          (keypress)="onKeyPress($event)"
          placeholder="Escribe tu mensaje aquí..."
          rows="1"
          class="flex-1 px-4 py-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none max-h-32"
        ></textarea>
        <button
          (click)="sendMessage()"
          [disabled]="userInput.trim() === '' || isTyping"
          class="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-semibold shadow-sm disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5" />
          </svg>
          Enviar
        </button>
      </div>
      <p class="text-xs text-gray-500 mt-2">Presiona Enter para enviar, Shift+Enter para nueva línea</p>
    </div>
  </div>
</div>
